<template>
	<!--块级按钮-->
	<button type="button" @click="$emit('click')" class="btn-block-lg ft-size-16" :class="classCpt">
		<slot>submit</slot>
	</button>
</template>
<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		props:['classCpt']
	}
</script>

<style scoped>
	button {
		line-height: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/btnBlock.vue